import { ReactNode } from 'react';
import { PiCheckFatFill } from 'react-icons/pi';
import './Timeline.scss';

interface ITimelineProps<T> {
  events: T[];
  name: (item: T) => ReactNode;
  isEventSelected: (item: T) => boolean;
}

const Timeline = <T,>({ events, name, isEventSelected }: ITimelineProps<T>) => {
  return (
    <div className='timeline'>
      {events.map(event => (
        <div
          className={`timeline-event ${
            isEventSelected(event) ? 'timeline-event-selected' : ''
          }`}>
          <div className='timeline-event-icon'>
            <PiCheckFatFill />
          </div>
          <div className='timeline-event-name'>{name(event)}</div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
